import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
import { z } from "zod";
import { ensureElementVisible } from "@/lib/route-guards";

const ListaOfertFm1Page = lazy(() =>
	import("@/features/rda/lista-ofert-fm1-page").then((m) => ({
		default: m.ListaOfertFm1Page,
	})),
);

// Filtry deep-linkowalne; kazdy z `.catch()` — zly param ze starej zakladki nie
// moze wywalic trasy ZodErrorem (FARMASTER-FRONTEND-31/33/34).
const searchSchema = z.object({
	active: z.boolean().optional().catch(undefined),
	today: z.boolean().optional().catch(undefined),
	automat: z.boolean().optional().catch(undefined),
	infoZam: z.boolean().optional().catch(undefined),
	from: z
		.string()
		.regex(/^\d{4}-\d{2}-\d{2}$/)
		.optional()
		.catch(undefined),
	to: z
		.string()
		.regex(/^\d{4}-\d{2}-\d{2}$/)
		.optional()
		.catch(undefined),
});

export type ListaOfertFm1Search = z.infer<typeof searchSchema>;

export const Route = createFileRoute("/_auth/rda/lista-ofert-fm1")({
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.rda.lista-ofert-fm1",
			location.pathname,
		);
	},
	component: ListaOfertFm1Page,
	validateSearch: (search: Record<string, unknown>): ListaOfertFm1Search =>
		searchSchema.parse(search),
});
